import styled from "styled-components";

// Тултип типа жидкости. Оформление — как у тултипа чартов: светлый бокс с рамкой,
// текст цвета textSecondary. Позиционируется по координатам курсора (position: fixed),
// поэтому не обрезается overflow-контейнером таблицы.
export const TooltipBox = styled.div`
  position: fixed;
  z-index: 1000;
  transform: translate(-50%, calc(-100% - 12px));
  pointer-events: none;
  white-space: nowrap;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textSecondary};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  box-shadow: ${({ theme }) => theme.shadow.medium};
  padding: 0.35rem 0.6rem;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  overflow: hidden;
`;

export const Title = styled.h3`
  margin: 0;
  padding: ${({ theme }) => theme.spacing.small};
  width: 100%;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
`;

export const TableScroll = styled.div`
  flex: 1;
  overflow: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.text};

  tbody tr {
    transition: background-color 0.15s;
  }

  tbody tr:hover {
    background: ${({ theme }) => theme.colors.treeNodeHover};
  }
`;

export const Th = styled.th`
  position: sticky;
  top: 0;
  z-index: 1;
  text-align: left;
  padding: 0.5rem 0.9rem;
  font-weight: ${({ theme }) => theme.typography.medium.fontWeight};
  font-size: ${({ theme }) => theme.typography.small.fontSize};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.mediumGrey};
  background: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
  white-space: nowrap;
`;

export const ThUnit = styled.span`
  display: block;
  margin-top: 0.15rem;
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  text-transform: none;
  color: ${({ theme }) => theme.colors.mediumGrey};
`;

export const Td = styled.td`
  padding: 0.5rem 0.9rem;
  vertical-align: top;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
`;

export const Description = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StageBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background: ${({ $color }) => $color};
  color: ${({ theme }) => theme.colors.stageBadge};
  font-size: ${({ theme }) => theme.typography.small.fontSize};
  font-weight: 600;
`;

export const EmptyMessage = styled.div`
  margin: auto;
  padding: 1rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.mediumGrey};
`;
